"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var InputAddon = function InputAddon(props) {
  return (0, _preact.h)("div", {
    className: 'input-group configurator__input-wrapper',
    style: {
      display: 'table'
    }
  }, (0, _preact.h)("input", {
    type: props.type,
    min: props.min,
    className: 'form-control',
    value: props.value,
    onChange: function onChange(e) {
      return props.onChange(e.target.value);
    }
  }), (0, _preact.h)("span", {
    className: 'configurator__input-addon input-group-addon'
  }, props.addon));
};

var _default = InputAddon;
exports.default = _default;